import { Divider as MantineDivider } from '@mantine/core'
import { DividerProps } from './divider.types'

export const Divider = ({ ...props }: DividerProps) => (
  <MantineDivider {...props} />
)
